import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToS_COOKIE } from '@global/GlobalFunctions';
import { ApplicationSettings } from '@services/application.service';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { CookieService } from 'ngx-cookie-service';
import { filter, firstValueFrom } from 'rxjs';

/** SLAComponent */
@Component({
	selector: 'app-tos',
	templateUrl: './tos.component.html',
	styleUrl: './tos.component.scss'
})
export class TOSComponent implements OnInit, AfterViewInit {

	/** slaContent */
	@ViewChild('tosContent')
	tosContent!: ElementRef<HTMLElement>;

	/** canAccept */
	canAccept = false;

	ToS_Version: number;
	ToS_Link:string;

	public appSettings: ApplicationSettings;

	/**
	 * constructor
	 * @param cookieService 
	 * @param router 
	 * @param SiteSubscriptions 
	 */
	constructor(
		private cookieService: CookieService,
		private router: Router,
		private SiteSubscriptions: siteSubscriptions
	) {

	}

	/**
	 * ngOnInit
	 */
	async ngOnInit() {

		try {
			this.appSettings = await firstValueFrom(
				this.SiteSubscriptions.applicationSettings$.pipe(
					filter(value => value && Object.keys(value).length > 0)
				)
			);

			if (this.appSettings) {
				this.ToS_Version = this.appSettings.Config.ToS.version;
				this.ToS_Link = this.appSettings.Config.ToS.link;
			}

		}
		catch (error) { }
	}



	/** ngAfterViewInit */
	ngAfterViewInit(): void {

		setTimeout(() => {
			this.checkScrollRequired();
		});
	}

	/** onScroll */
	onScroll(): void {

		const element = this.tosContent.nativeElement;

		const reachedBottom =
			element.scrollTop + element.clientHeight >= element.scrollHeight - 5;

		if (reachedBottom) {
			this.canAccept = true;
		}
	}

	/** checkScrollRequired */
	private checkScrollRequired(): void {

		// const element = this.tosContent.nativeElement;

		// // If the content fits entirely, there is nothing to scroll.
		// if (element.scrollHeight <= element.clientHeight) {
		// 	this.canAccept = true;
		// }

		this.canAccept = true;

	}

	/** accept */
	accept(): void {

		if (!this.canAccept) {
			return;
		}

		this.cookieService.set(
			ToS_COOKIE,
			this.ToS_Version.toString(),
			{
				expires: 365,
				path: '/'
			}
		);

		this.router.navigate(['/'], { replaceUrl: true });
	}

	/** decline */
	decline(): void {

		this.cookieService.delete(ToS_COOKIE, '/');
		this.router.navigate(['/logout']);

	}
}